<!-- NUOVA SEZ BIBLIOTECA -->
<ul class="nav nav-tabs w-100" role="tablist">
    <li class="nav-item col-6 text-center" role="presentation">
        <a class="nav-link active text-uppercase text-brand-40 ls-label-small-semibold" id="tab-catalogo"
            data-bs-toggle="tab" href="#tab-catalogo-panel" role="tab" aria-controls="tab-catalogo-panel"
            aria-selected="true">Catalogo Lumsa</a>
    </li>
    <li class="nav-item col-6 text-center" role="presentation">
        <a class="nav-link text-uppercase text-brand-40 ls-label-small-semibold" id="tab-discovery" data-bs-toggle="tab"
            href="#tab-discovery-panel" role="tab" aria-controls="tab-discovery-panel" aria-selected="false">Discovery
            service</a>
    </li>
</ul>
<div class="tab-content bg-brand-99 pt-5" id="tab-content">
    <div class="tab-pane active bg-brand-99" id="tab-catalogo-panel" role="tabpanel" aria-labelledby="tab-catalogo">
        <div class="container-search-library">
            <div class="container-search-library__container-title">
                <h2 *ngIf="block.titolo" class="ls-h2-section-title text-brand-10" [innerHTML]="block.titolo"></h2>
                <p *ngIf="block.sottotitolo" class="ls-p text-neutral-40" [innerHTML]="block.sottotitolo"></p>
            </div>
            <div class="container-search-library__container-input position-relative container-xxl">
                <input class="form-control" type="text" (keydown.enter)="search()"
                    placeholder="{{'SEARCH_BAR.PLACEHOLDER_SEARCH_CATALOG' | translate}}" [formControl]="searchLibrary"
                    [ngClass]="{'border-custom': searchLibrary.value}">
                <div class="container-search-library__container-input__container-image cursor-pointer"
                    (click)="search()">
                    <img loading="lazy" src="../../../../../assets/images/search.png" alt="search icon">
                </div>
            </div>
            <div class="container-search-library__container-cta d-flex justify-content-center">
                <button *ngIf="true" class="btn btn-success ls-label-medium-semibold text-uppercase"
                    (click)="search()" >{{"SEARCH_BAR.SEARCH" | translate}}</button>
            </div>
            <div class="container-search-library__container-cta-external d-flex justify-content-center">
                <a href="https://cloud.sbn.it/opac2/IEI/LU/ricercaAvanzata" target="_blank">
                    <p class="text-uppercase text-brand-40 ls-label-small-semibold me-5">
                        {{"SEARCH_BAR.ADVANCED_SEARCH" | translate}}
                    </p>
                </a>
                <a href="https://cloud.sbn.it/opac2/IEI/" target="_blank">
                    <p class="text-uppercase text-brand-40 ls-label-small-semibold">
                        {{"SEARCH_BAR.CATALOG" | translate}}
                    </p>
                </a>
            </div>
        </div>
    </div>
    <div class="tab-pane bg-brand-99" id="tab-discovery-panel" role="tabpanel" aria-labelledby="tab-discovery">
        <!-- DISCOVERY SERVICE -->
        <div class="container-search-library">
            <div class="container-search-library__container-title">
                <h2 class="ls-h2-section-title text-brand-10">{{'SEARCH_BAR.SUBTITLE_DISCOVERY_SERVICE' | translate}}</h2>
                <!-- <p class="ls-p text-neutral-40"></p> -->
            </div>
            <div class="container-search-library__container-input position-relative container-xxl">
                <form ngNoForm #formSearch action="https://search.ebscohost.com/login.aspx" class="unpadded"
                    id="ebscohostCustomSearchBox" method="get" target="_blank">
                    <div>
                        <input name="direct" type="hidden" value="true" />
                        <input name="site" type="hidden" value="eds-live" />
                        <input name="scope" type="hidden" value="site" />
                        <input name="type" type="hidden" value="0" />
                        <input name="custid" type="hidden" value="ns022872" />
                        <input name="groupid" type="hidden" value="main" />
                        <input name="profid" type="hidden" value="eds" />
                        <input name="mode" type="hidden" value="and" />
                        <input name="lang" type="hidden" value="IT" />
                        <input name="authtype" type="hidden" value="ip,guest,uid" />
                    </div>
                    <input id="bquery" name="bquery" class="form-control" type="text"
                        placeholder="{{'SEARCH_BAR.PLACEHOLDER_DISCOVERY_SERVICE' | translate}}"
                        [formControl]="searchLibrary" [ngClass]="{'border-custom': searchLibrary.value}">
                    <div class="container-search-library__container-input__container-image cursor-pointer"
                        (click)="formSearch.submit()" style="top: 22%;">
                        <img loading="lazy" src="./assets/images/search.png" alt="search icon">
                    </div>
                    <div class="container-search-library__container-cta d-flex justify-content-center"
                        style="margin-top: 48px;">
                        <button class="btn btn-success ls-label-medium-semibold text-uppercase" type="submit"
                            value="Cerca">{{"SEARCH_BAR.SEARCH" | translate}}
                        </button>
                    </div>
                </form>
            </div>
            <div class="container-search-library__container-cta-external d-flex justify-content-center">
                <!-- <a href="http://search.ebscohost.com/login.aspx?authtype=ip,guest&amp;custid=ns022872&amp;profile=eds&amp;groupid=main"
                    target="_blank">
                    <p class="text-uppercase text-brand-40 ls-label-small-semibold me-5">
                        {{"SEARCH_BAR.BASIC_SEARCH" | translate}}
                    </p>
                </a> -->
                <a href="http://search.ebscohost.com/login.aspx?direct=true&amp;type=1&amp;authtype=ip,guest&amp;custid=ns022872&amp;groupid=main&amp;profile=eds"
                    target="_blank">
                    <p class="text-uppercase text-brand-40 ls-label-small-semibold">
                        {{"SEARCH_BAR.ADVANCED_SEARCH" | translate}}
                    </p>
                </a>
            </div>
        </div>
    </div>
</div>